import { Renderer } from '@unseenco/taxi'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Fancybox } from "@fancyapps/ui/dist/fancybox/"
import "@fancyapps/ui/dist/fancybox/fancybox.css"

import { initialTransition } from '../transitions/initial'

import lenis from '../components/lenis'
import initAccordion from '../components/accordion'
import initArticle from '../components/article'
import initCarousel from '../components/carousel'
import initExclusiveUse from '../components/exclusive-use'
import initFilter from '../components/filter'
import initFooter from '../components/footer'
import initGallery from '../components/gallery'
import initHeader from '../components/header'
import initHero from '../components/hero'
import initMap from '../components/map'
import initModal from '../components/modal'
import initNavMenu from '../components/nav-menu'
import initPageNav from '../components/page-nav'
import initParallax from '../components/parallax'
import initReveal from '../components/reveal'
import initSearch from '../components/search'
import initStickyFeatures from '../components/sticky-features'
import initVideo from '../components/video'
import initVenobox from '../components/venobox'
import initLazyLoad from '../components/lazyload'

gsap.registerPlugin(ScrollTrigger)

const refreshScrollTrigger = () => ScrollTrigger.refresh()

// Scripts to load on initial page entry
function initialScripts() {
	initialTransition()
}

// Scripts to load on every page entry
function enterScripts() {

	lenis.start()

	initAccordion()
	initArticle()
	initCarousel()
	initExclusiveUse()
	initFilter()
	initFooter()
	initGallery()
	initHeader()
	initHero()
	initMap()
	initModal()
	initNavMenu()
	initPageNav()
	initParallax()
	initReveal()
	initSearch()
	initStickyFeatures()
	initVideo()
	initVenobox()
	initLazyLoad()

	if (document.querySelector('[data-fancybox]')) {
		Fancybox.unbind('[data-fancybox]')
		Fancybox.bind("[data-fancybox]", {
			Carousel: {
				Thumbs: false,
				Toolbar: {
					display: {
						left: [""],
						middle: [""],
						right: ["close"],
					},
				},
			},
			on: {
				"init": () => {
					lenis.stop()
				},
				"destroy": () => {
					lenis.start()
				},
			},
		})
	}

	const bodyScrollbarWidth = window.innerWidth - document.documentElement.clientWidth
	document.body.style.setProperty('--body-scrollbar-width', `${bodyScrollbarWidth}px`)

	if (window.location.hash.length) {
		const hash = window.location.hash.split('&')
		const anchor = document.getElementById(decodeURIComponent(hash[0].replace('#', '')))

		if (anchor) {
			let anchorDistance = window.scrollY + anchor.getBoundingClientRect().top
			window.scrollTo({ top: anchorDistance, left: 0, behavior: 'instant' })
		}
	} else {
		window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
	}
	ScrollTrigger.refresh()

	var vids = document.querySelectorAll('video[autoplay]')
	vids.forEach((vid) => {
		var playPromise = vid.play()
		if (playPromise !== undefined) {
			playPromise.then((_) => { }).catch((error) => { })
		}
	})

	document.querySelectorAll('img').forEach((img) => {
		if (img.complete) {
			ScrollTrigger.refresh()
		} else if (!img.dataset.scrollRefreshBound) {
			img.dataset.scrollRefreshBound = 'true'
			img.addEventListener('load', refreshScrollTrigger, { once: true })
		}
	})
}

export default class DefaultRenderer extends Renderer {
	initialLoad() {
		initialScripts()
		this.onEnter()
		this.onEnterCompleted()
	}

	onLeave() {
		ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
		Fancybox.close(true)
		Fancybox.unbind('[data-fancybox]')
	}

	onLeaveCompleted() {
		document.documentElement.classList.remove(
			'lenis-stopped',
			'overflow-hidden',
		)
	}

	onEnter() {
		enterScripts()
	}

	onEnterCompleted() { }
}
